/* eslint-disable camelcase */
/* eslint-disable no-undef */
import React, {useState} from "react";
import styles from "./ContactUs.module.scss";
import {useForm, Controller} from "react-hook-form";
import {Button, Form, Modal, Input} from "antd";
import {ToastContainer, toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {default as ReactSelect} from "react-select";

const {TextArea} = Input;
const interests = [
  {label: "Select All", value: "select all"},
  {label: "Jobs", value: "jobs"},
  {label: "Candidates", value: "candidates"},
  {label: "Employees", value: "employees"},
  {label: "Applicants", value: "applicants"},
  {label: "Communications", value: "communications"},
  {label: "Campaigns", value: "campaigns"},
  {label: "Parsers", value: "parsers"},
  {label: "AI Matching", value: "ai_matching"},
  {label: "Prediction", value: "prediction"},
  {label: "Hiring Manager", value: "hiring_manager"},
  {label: "Evalutions", value: "evalutions"},
  {label: "User Management", value: "user_management"},
];

const allOptions = [{label: "Select All", value: "select all"}];

const ContactUs = () => {
  const form = useForm({mode: "all"});
  const {control, handleSubmit, formState, reset} = form;
  const {errors} = formState;
  const [loadings, setLoadings] = useState(false);

  const CustomOption = ({innerProps, isSelected, children}) => {
    const handleChecked = () => {
      if (children === "Select All") {
        if (selectedOptions.length === interests.length - 1) {
          return true;
        } else {
          return false;
        }
      } else {
        return isSelected;
      }
    };
    return (
      <div
        {...innerProps}
        style={{
          padding: "5px",
          cursor: "pointer",
          fontSize: "18px",
        }}
      >
        <input
          type="checkbox"
          className={styles.input_field}
          checked={handleChecked()}
          readOnly
          style={{margin: "5px", textAlign: "center", fontSize: "18px"}}
        />
        {children}
      </div>
    );
  };

  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleChange = (selected) => {
    // remove select all option from interests when clicked on select all
    const removeSelectAllOption = selected.filter(
      (item) => item.value !== "select all",
    );
    setSelectedOptions(removeSelectAllOption);
  };
  const deSelectAll = () => {
    setSelectedOptions([]);
  };

  const [modalOpen, setModalOpen] = useState(false);
  const UserSignUp_url = process.env.REACT_APP_END_POINT || "https://dev-spx-api-gateway-service.phenompro.com/api-gateway-service/";
  const onSubmit = async (data) => {
    const options = selectedOptions?.map((item) => item.label);
    data = {...data, interests: options};
    try {
      setLoadings(true);
      const response = await fetch(UserSignUp_url+"userSignUp", {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      setLoadings(false);
      if (response.ok) {
        setModalOpen(true);
        setSelectedOptions([]);
        setTimeout(() => {
          setModalOpen(false);
        }, 5000);
        reset();
      } else {
        toast("Please try again later");
        setLoadings(false);
      }
    } catch (error) {
      toast("Please try again later");
      setLoadings(false);
    }
  };

  return (
    <div
      style={{
        marginTop: "78px",
        display: "grid",
        placeItems: "center",
        overflow: "none !important",
        backgroundColor: "#f7f7f7",
      }}
      className={styles.main_container}
      data-index={3}
      id="Contact Us"
    >
      <h1 id="Getting Started" className="side-menu-methods">
        Contact Us
      </h1>
      <div style={{width: "70%", display: "grid", placeItems: "center"}}>
        <Form onFinish={handleSubmit(onSubmit)} layout="vertical">
          <div className={styles.input_wrapper}>
            <div className={styles.field_wrapper}>
              <Form.Item
                label={
                  <>
                    <span className={styles.input_label}>First Name</span>
                    <span className={styles.required_field}>*</span>
                  </>
                }
                validateStatus={errors.firstName ? "error" : ""}
                help={errors.firstName?.message}
              >
                <Controller
                  name="firstName"
                  control={control}
                  rules={{required: "Please complete this required field."}}
                  render={({field}) => (
                    <Input
                      placeholder="Enter your first name"
                      className={styles.input_field}
                      {...field}
                    />
                  )}
                />
              </Form.Item>
            </div>
            <div className={styles.field_wrapper}>
              <Form.Item
                label={
                  <>
                    <span className={styles.input_label}>Last Name</span>
                    <span className={styles.required_field}>*</span>
                  </>
                }
                validateStatus={errors.lastName ? "error" : ""}
                help={errors.lastName?.message}
              >
                <Controller
                  name="lastName"
                  control={control}
                  rules={{required: "Please complete this required field."}}
                  render={({field}) => (
                    <Input
                      placeholder="Enter your last name"
                      className={styles.input_field}
                      {...field}
                    />
                  )}
                />
              </Form.Item>
            </div>
          </div>
          <div className={styles.input_wrapper}>
            <div className={styles.field_wrapper}>
              <Form.Item
                label={
                  <>
                    <span className={styles.input_label}>Email</span>
                    <span className={styles.required_field}>*</span>
                  </>
                }
                validateStatus={errors.email ? "error" : ""}
                help={errors.email?.message}
              >
                <Controller
                  name="email"
                  control={control}
                  rules={{
                    required: "Please complete this required field.",
                    pattern: {
                      value: /^(?!.*@(?:gmail|yahoo)\.com).*@.*$/,
                      message:
                        "Please enter a different email address. This form does not accept addresses from gmail.com and yahoo.com",
                    },
                  }}
                  render={({field}) => (
                    <Input
                      placeholder="Work Email"
                      className={styles.input_field}
                      {...field}
                    />
                  )}
                />
              </Form.Item>
            </div>

            <div className={styles.field_wrapper}>
              <Form.Item
                label={
                  <>
                    <span className={styles.input_label}>Phone Number</span>
                    <span className={styles.required_field}>*</span>
                  </>
                }
                validateStatus={errors.mobile ? "error" : ""}
                help={errors.mobile?.message}
              >
                <Controller
                  name="mobile"
                  control={control}
                  rules={{
                    required: "Please complete this required field.",
                    pattern: {
                      value: /^[\d\(\)\-+]+$/,
                      message: "phone number should contain only numbers",
                    },
                  }}
                  render={({field}) => (
                    <Input
                      placeholder="+(country code) number"
                      className={styles.input_field}
                      {...field}
                    />
                  )}
                />
              </Form.Item>
            </div>
          </div>
          <div className={styles.field_wrapper}>
            <Form.Item
              label={
                <>
                  <span className={styles.input_label}>Company Name</span>
                  <span className={styles.required_field}>*</span>
                </>
              }
              validateStatus={errors.companyName ? "error" : ""}
              help={errors.companyName?.message}
            >
              <Controller
                name="companyName"
                control={control}
                rules={{required: "Please complete this required field."}}
                render={({field}) => (
                  <Input
                    placeholder="Company Name"
                    {...field}
                    className={styles.input_field}
                  />
                )}
              />
            </Form.Item>
          </div>
          <div className={styles.check_box}>
            <Form.Item
              label={
                <span className={styles.input_label}>
                  What would you like to focus the conversation on?
                </span>
              }
              validateStatus={errors.interests ? "error" : ""}
              help={errors.interests?.message}
            >
              <Controller
                name="interests"
                control={control}
                render={() => (
                  <ReactSelect
                    className={styles.select_field}
                    options={interests}
                    value={selectedOptions}
                    // onChange={handleChange}
                    onChange={(selected) => {
                      if (
                        selected !== null &&
                        selected.length > 0 &&
                        selected[selected.length - 1].value ===
                          allOptions[0].value
                      ) {
                        if (selectedOptions.length === interests.length - 1) {
                          return deSelectAll();
                        }
                        return handleChange(interests);
                      }
                      return handleChange(selected);
                    }}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{
                      Option: (props) => (
                        <CustomOption
                          {...props}
                          selectedOptions={selectedOptions}
                        />
                      ),
                    }}
                  />
                )}
              />
            </Form.Item>
          </div>
          <div className={styles.message_field}>
            <Form.Item
              label={<span className={styles.input_label}>Message</span>}
            >
              <Controller
                name="message"
                control={control}
                render={({field}) => <TextArea {...field} rows={4} />}
              />
            </Form.Item>
          </div>

          <Button
            htmlType="submit"
            type="primary"
            loading={loadings}
            style={{
              display: "inline-block",
              width: "6rem",
              cursor: "pointer",
              fontSize: "16px",
              backgroundColor: "#4035de",
              color: "#fff",
              textDecoration: "none",
              borderRadius: "50px",
              marginBottom: "10px",
              textAlign: "center",
              padding: "0 16px",
            }}
          >
            Submit
          </Button>
          <ToastContainer
            position="bottom-right"
            autoClose={5000}
            theme="light"
          />
          <Modal
            title=""
            centered
            open={modalOpen}
            onCancel={() => setModalOpen(false)}
            className={styles.modal}
            footer={null}
          >
            <p>
              Thank you for registering! The Phenom team will contact with you
              soon.
            </p>
          </Modal>
        </Form>
      </div>
    </div>
  );
};

export default ContactUs;
